module.exports = __webpack_public_path__ + "img/ins.3b89806.svg";